import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQueries } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { PeriodAnalysisRequest, PeriodAnalysisResponse, PeriodAnalysisData } from "./types";

export const periodAnalysis = createQueryKeys('periodAnalysis', {
  detail: (request: PeriodAnalysisRequest) => ({
    queryKey: [request.installation_id, request.start, request.end, request.metric, request.target_unit, request.sensor_name],
    queryFn: async () => {
      const response = await apiClient.post<PeriodAnalysisResponse>(
        'on-periods/period-analysis/',
        request
      );
      return response.data;
    },
  }),
});

const hasCycleData = (data: PeriodAnalysisData | undefined): boolean => {
  if (!data) return false;
  return data.series.length > 0 && data.series.some(series => series.data.length > 0);
};

export const useMultiplePeriodAnalysis = (requests: PeriodAnalysisRequest[]) => {
  return useQueries({
    queries: requests.map(request => ({
      ...periodAnalysis.detail(request),
    })),
    combine: (results) => ({
      results,
      hasAnyCycles: results.some(result => hasCycleData(result.data?.data)),
      isAnyLoading: results.some(result => result.isPending),
      isAnyFetching: results.some(result => result.isFetching),
    })
  });
};
